import {
	GetPlayerWithDepositsWithoutPromotionRequest,
	GetPlayerWithDepositsWithoutPromotionResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithDepositsWithoutPromotion } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithDepositsWithoutPromotion(
	payload: GetPlayerWithDepositsWithoutPromotionRequest,
	props?: UseBaseQueryOptions<GetPlayerWithDepositsWithoutPromotionResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithDepositsWithoutPromotion, payload],
		queryFn: () => getPlayerWithDepositsWithoutPromotion(payload),
		...props,
	})
}
